const list = ['KW61','X615','LP76',];
const gifList = []; 
const ajax_url = 'https://tool.m3guo.com/api/web/m3goods/eq-item/';
const img_src = 'https://web-resource.17m3.com/m3guo/202309/recruit/tips/';
const img_file = '.png';

export default{
    list,
    gifList,
    ajax_url,
    img_src,
    img_file,
}


// WEBPACK FOOTER //
// ./src/directives/config/tipsConfig.js